// eslint-disable-next-line import/prefer-default-export
export const ZINDEX_GLOBAL_SEARCH = 8000;
